import { USER_MANAGEMENT } from '@/constants';
import { faker } from '@faker-js/faker';

const mockRoles = () => Object.values(USER_MANAGEMENT.ROLES);

const mockRoleUser = () => {
  const roles = mockRoles();
  const firstname = faker.person.firstName();
  const lastname = faker.person.lastName();
  const item = {
    created_at: faker.date.past(),
    email: faker.internet.email({
      firstName: firstname,
      lastName: lastname,
    }),
    firstname,
    lastname,
    role: faker.helpers.arrayElement(roles),
    user_id: faker.string.uuid(),
  };
  return item;
};

const mockRoleUsers = (items = 10) =>
  faker.helpers.multiple(() => mockRoleUser(), { count: items });

export { mockRoles, mockRoleUser, mockRoleUsers };
